import ExternalIntegrationLink from 'components/ExternalIntegrationLink';

export default function MarketingIntegrationLink({
    href,
    integrationName,
    className,
}: {
    href: string;
    integrationName: string;
    className?: string;
}) {
    return <ExternalIntegrationLink href={href} label={integrationName} className={className} />;
}
